export const User = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="user"
  >
    <path
      d="M12 22.5C17.7978 22.5 22.5 17.7978 22.5 12C22.5 6.20218 17.7978 1.5 12 1.5C6.20218 1.5 1.5 6.20218 1.5 12C1.5 17.7978 6.20218 22.5 12 22.5Z"
      stroke="#707475"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.0005 12.913C14.1461 12.913 15.8809 11.1783 15.8809 9.0326C15.8809 6.88694 14.1461 5.15216 12.0005 5.15216C9.85484 5.15216 8.12006 6.88694 8.12006 9.0326C8.12006 11.1783 9.85484 12.913 12.0005 12.913Z"
      stroke="#707475"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.7704 17.9348C16.7112 15.7069 14.4652 14.2826 11.9999 14.2826C9.53471 14.2826 7.28862 15.7069 6.22949 17.9348"
      stroke="#707475"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
